import { render, staticRenderFns } from "./Wap.vue?vue&type=template&id=a6c76e30&scoped=true&"
import script from "./Wap.vue?vue&type=script&lang=js&"
export * from "./Wap.vue?vue&type=script&lang=js&"
import style0 from "./Wap.vue?vue&type=style&index=0&id=a6c76e30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c76e30",
  null
  
)

export default component.exports